import React, { useState, useEffect } from 'react';
import { getPageContent, subscribeToPage } from '../firebase/firebase-config';

function Notices() {
  const [content, setContent] = useState({ notices: [], showNoticeBanner: 'no', noticeBannerTitle: '', noticeBannerMessage: '', noticeBannerImage: '', noticeBannerVideo: '', sliderImages: [] });
  const [loading, setLoading] = useState(true);
  const [showOld, setShowOld] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await getPageContent('notices');
        setContent(data);
      } catch (error) { console.error(error); }
      finally { setLoading(false); }
    };
    loadData();
    const unsubscribe = subscribeToPage('notices', (data) => { if (data) setContent(data); });
    return () => unsubscribe();
  }, []);

  const getYouTubeId = (url) => { const match = url?.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/); return match ? match[1] : null; };
  const filteredNotices = (content.notices || []).filter(n => showOld ? true : !n.isOld);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="notices-page">
      {content.sliderImages && content.sliderImages.length > 0 && (<div className="page-banner"><img src={content.sliderImages[0].url} alt="Notices" /><div className="banner-overlay"><h1>Notices & Announcements</h1></div></div>)}
      {content.showNoticeBanner === 'yes' && (<div className="notice-banner">{content.noticeBannerImage && <img src={content.noticeBannerImage} alt="Banner" />}{content.noticeBannerVideo && <iframe src={`https://www.youtube.com/embed/${getYouTubeId(content.noticeBannerVideo)}`} frameBorder="0"></iframe>}<div><h3>{content.noticeBannerTitle}</h3><p>{content.noticeBannerMessage}</p></div></div>)}
      <div className="container"><div className="filter"><button className={!showOld ? 'active' : ''} onClick={() => setShowOld(false)}>Latest Notices</button><button className={showOld ? 'active' : ''} onClick={() => setShowOld(true)}>Archived Notices</button></div>
      <div className="notices-list">{filteredNotices.map((notice, idx) => (<div key={idx} className={`notice-card ${notice.isOld ? 'old' : 'new'}`}><div className="notice-date">{notice.date ? new Date(notice.date).toLocaleDateString() : 'New'}</div><div className="notice-content"><h3>{notice.title}</h3><p>{notice.content}</p>{notice.file && <a href={notice.file.url} download>📎 Download Attachment</a>}</div></div>))}</div></div>
      <style>{`
        .notices-page { background: #f8fafc; min-height: 100vh; }
        .page-banner { position: relative; height: 300px; overflow: hidden; }
        .page-banner img { width: 100%; height: 100%; object-fit: cover; }
        .banner-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; }
        .banner-overlay h1 { color: white; font-size: 48px; }
        .notice-banner { background: #f59e0b; padding: 15px 20px; display: flex; align-items: center; gap: 20px; flex-wrap: wrap; color: #1a0000; }
        .notice-banner img { height: 60px; border-radius: 8px; }
        .notice-banner iframe { width: 100px; height: 60px; border-radius: 8px; }
        .container { max-width: 1200px; margin: 0 auto; padding: 60px 20px; }
        .filter { display: flex; gap: 15px; margin-bottom: 30px; justify-content: center; }
        .filter button { padding: 10px 24px; border: 2px solid #1a3a6b; background: white; color: #1a3a6b; border-radius: 30px; cursor: pointer; font-weight: 600; transition: all 0.3s; }
        .filter button.active { background: #1a3a6b; color: white; }
        .notices-list { display: flex; flex-direction: column; gap: 20px; }
        .notice-card { display: flex; gap: 20px; background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1); transition: transform 0.3s; }
        .notice-card:hover { transform: translateX(5px); }
        .new { border-left: 4px solid #f59e0b; }
        .old { opacity: 0.7; border-left: 4px solid #94a3b8; }
        .notice-date { min-width: 100px; background: #1a3a6b; color: white; display: flex; align-items: center; justify-content: center; padding: 15px; font-weight: 600; text-align: center; }
        .notice-content { padding: 20px; flex: 1; }
        .notice-content h3 { color: #1a3a6b; margin-bottom: 8px; }
        .notice-content p { color: #64748b; margin-bottom: 10px; }
        .notice-content a { color: #f59e0b; text-decoration: none; }
        .loading { display: flex; justify-content: center; align-items: center; min-height: 60vh; }
        .spinner { width: 50px; height: 50px; border: 4px solid #e2e8f0; border-top-color: #1a3a6b; border-radius: 50%; animation: spin 1s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 768px) { .banner-overlay h1 { font-size: 32px; } .notice-card { flex-direction: column; } .notice-date { min-width: auto; } }
      `}</style>
    </div>
  );
}
export default Notices;